import $ from 'jquery'

export class TabTutorial {

  constructor($container)
  {
			// this.$ = $container.find('.tab-tutorial-')
  }

}
